module.exports = __webpack_public_path__ + "img/微博logo.904aa6fd.png";